"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDebugStateSelector = void 0;
var re_reselect_1 = __importDefault(require("re-reselect"));
var constants_1 = require("../../../../common/constants");
var get_chart_id_1 = require("../../../../state/selectors/get_chart_id");
var viewmodel_1 = require("../../layout/viewmodel/viewmodel");
var geometries_1 = require("./geometries");
exports.getDebugStateSelector = re_reselect_1.default([geometries_1.partitionMultiGeometries], function (geoms) {
    return {
        partition: geoms.reduce(function (acc, _a) {
            var panelTitle = _a.panelTitle, config = _a.config, quadViewModel = _a.quadViewModel, diskCenter = _a.diskCenter;
            var partitions = quadViewModel.map(function (model) {
                var dataName = model.dataName, depth = model.depth, fillColor = model.fillColor, value = model.value;
                return {
                    name: dataName,
                    depth: depth,
                    color: fillColor,
                    value: value,
                    coords: viewmodel_1.isSunburst(config.partitionLayout)
                        ? getCoordsForSector(model, diskCenter)
                        : getCoordsForRectangle(model, diskCenter),
                };
            });
            acc.push({
                panelTitle: panelTitle,
                partitions: partitions,
            });
            return acc;
        }, []),
    };
})(get_chart_id_1.getChartIdSelector);
function getCoordsForSector(_a, diskCenter) {
    var x0 = _a.x0, x1 = _a.x1, y1px = _a.y1px, y0px = _a.y0px;
    var X0 = x0 - constants_1.TAU / 4;
    var X1 = x1 - constants_1.TAU / 4;
    var cr = y0px + (y1px - y0px) / 2;
    var angle = X0 + (X1 - X0) / 2;
    var x = Math.round(Math.cos(angle) * cr + diskCenter.x);
    var y = Math.round(Math.sin(angle) * cr + diskCenter.y);
    return [x, y];
}
function getCoordsForRectangle(_a, diskCenter) {
    var x0 = _a.x0, x1 = _a.x1, y1px = _a.y1px, y0px = _a.y0px;
    var y = Math.round(y0px + (y1px - y0px) / 2 + diskCenter.y);
    var x = Math.round(x0 + (x1 - x0) / 2 + diskCenter.x);
    return [x, y];
}
//# sourceMappingURL=get_debug_state.js.map